module.exports = __webpack_public_path__ + "img/menu-mobile-white.a5e7a72d.svg";